import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_EVENT_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { PinterestParams } from '../../entities';
import { PinterestService } from '../../interfaces';

export class HttpPinterestService implements PinterestService {
  constructor(
    private readonly observabilitySystem: ObservabilitySystem,
    private readonly funnelSettingsService: FunnelSettingsServiceInterface,
  ) {}

  lead(orderId: string) {
    this.track('lead', {
      event_id: orderId,
      lead_type: 'Newsletter',
    });
  }

  checkout({ price, orderId, currency }: PinterestParams) {
    this.track('checkout', {
      event_id: orderId,
      currency: currency,
      value: price,
    });
  }

  track(name: string, params?: Record<string, unknown>) {
    const spanAttributes = {
      [ATTRS_ANALYTICS_EVENT_NAME]: name,
      [ATTRS_ANALYTICS_FUNNEL_NAME]: this.funnelSettingsService.getFunnelName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: this.funnelSettingsService.getFunnelLocale(),
    };

    const span = this.observabilitySystem.startSpan(SpanName.TRACK_ANALYTICS_PINTEREST);
    span.setAttributes(spanAttributes);

    try {
      span.addEvent('Pending');
      window.pintrk('track', name, params);

      span.addEvent('Succeed');
      span.succeed();
    } catch (err) {
      const error = normalizeError(err);

      span.addEvent('Failed');
      span.fail(error);
    }
  }
}
